// extracted by mini-css-extract-plugin
export default {"btn":"ReadMore_btn__A7BoG"};